import React, { useEffect, useRef, useState } from 'react';
import { ANALYTICS } from '@latitude/core/utils/constants';
import { AnalyticsContext, AnalyticsLocationProvider } from 'latitude-analytics';
import BrandButton from './BrandButton';
import BrokerLoginButton from './BrokerLoginButton';
import BrokerLoginModal from './BrokerLoginModal';
import { BrokerHeaderWrapper, BrokerHeaderInnerWrapper } from './BrokerHeader.styled';

var BrokerHeader = function BrokerHeader(_ref) {
  var headerData = _ref.headerData;

  var _useState = useState(false),
      isModalActive = _useState[0],
      setIsModalActive = _useState[1];

  var wrapperRef = useRef(null);

  var handleClickOutside = function handleClickOutside(event) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsModalActive(false);
    }
  };

  useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: ANALYTICS.LOCATION.HEADER
  }, /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, function (_ref2) {
    var analytics = _ref2[0];
    return /*#__PURE__*/React.createElement(BrokerHeaderWrapper, {
      "data-sticky-navigation-offset": true
    }, /*#__PURE__*/React.createElement(BrokerHeaderInnerWrapper, {
      ref: wrapperRef
    }, /*#__PURE__*/React.createElement(BrandButton, {
      site: headerData.site
    }), /*#__PURE__*/React.createElement(BrokerLoginButton, {
      isModalActive: isModalActive,
      setIsModalActive: setIsModalActive,
      analytics: analytics
    }), /*#__PURE__*/React.createElement(BrokerLoginModal, {
      isModalActive: isModalActive,
      modalItems: headerData.modalItems
    })));
  }));
};

export default BrokerHeader;